/* eslint-disable prettier/prettier */
export default {"buildDate":1779463044847,"version":"1.2.5","build":"2c553d06","env":"production"};